import * as React from "react";
import { User, Customer, Elavtal, SelfServiceClient } from "../api/ApiClient";

const context = "userContext.";
export const UserContextContants = {
  tokenStorage: context + "token",
  userStorage: context + "user",
  customerStorage: context + "customer",
  elavtalStorage: context + "elavtal",
  currentElavtalStorage: context + "currentElavtal"
};

export interface UserContextModel {
  token: string;
  user: User;
  customer: Customer;
  elavtal: Elavtal[];
  currentElavtal: Elavtal;

  getClient(): SelfServiceClient;

  setToken(token: string): void;
  setUser(user: User): void;
  setCustomer(customer: Customer): void;
  setElavtal(elavtal: Elavtal[]): void;
  setCurrentElavtal(elavtal: Elavtal): void;
  clear(): void;
}

export const UserContext = React.createContext<UserContextModel>(undefined);
